import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import type { NextPage } from 'next';
import Link from 'next/link'
import cName from "classnames";
import styles from './index.module.scss';
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation';
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import Wrapper from '@/components/wrapper';
import classNames from 'classnames';
import CountUp from 'react-countup';
import * as echarts from 'echarts';
import { getServerSideProps as _getServerSideProps, getHead } from '@/utils/useHead';
import request from '@/utils/request';
import { useTranslations } from "next-intl";
import { useRouter } from "next/router";

interface IProps {

}
export async function getServerSideProps(context: any) {
  const res: any = await _getServerSideProps(context);
  const { data } = await request.get(`/api/get_summit`, {
    params: {
      lang: context.locale || 'cn'
    }
  })
  const { data: data2 }: any = await request.get(`/api/get_partner_list`, {
    params: {
      category_id: 11,
      rows: 99999,
      lang: context.locale || context.defaultLocale || 'cn'
    }
  })
  return {
    props: {
      ...res.props,
      data: data?.data || null,
      guestList: data2?.data?.data || null,
    }
  }
}

export default ({ menuDetail, data, guestList }: any) => {
  const router = useRouter();
  const t = useTranslations("summit.previous");

  const pieRef = useRef<any>()
  const barRef = useRef<any>()
  const pieOption = {
    tooltip: {
      trigger: 'item'
    },
    series: [
      {
        type: "pie",
        radius: ["40%", "70%"],
        animationDuration: 2000,
        padAngle: 2,
        itemStyle: {
          borderRadius: 10,
        },
        data: [
          {
            value: t('section5.chart1.item1num'),
            itemStyle: { color: "#a9acf4" },
            name: t('section5.chart1.item1tit'),
          },
          {
            value: t('section5.chart1.item2num'),
            itemStyle: { color: "#7ce1cf" },
            name: t('section5.chart1.item2tit'),
          },
          {
            value: t('section5.chart1.item3num'),
            itemStyle: { color: "#b5e1a6" },
            name: t('section5.chart1.item3tit'),
          },
          {
            value: t('section5.chart1.item4num'),
            itemStyle: { color: "#cde166" },
            name: t('section5.chart1.item4tit'),
          },
          {
            value: t('section5.chart1.item5num'),
            itemStyle: { color: "#f7cd45" },
            name: t('section5.chart1.item5tit'),
          },
          {
            value: t('section5.chart1.item6num'),
            itemStyle: { color: "#eb9435" },
            name: t('section5.chart1.item6tit'),
          },
        ],
        label: {
          alignTo: 'edge',
          formatter: function (params: any) {
            const arr = ['zero', 'one', 'two', 'three', 'four', 'five'];
            return '{a|' + params.value + '%}' + '\n' + '{name|' + params.name + '}';
          },
          minMargin: 5,
          edgeDistance: 60,
          overflow: 'none',
          lineHeight: 15,
          offset: [0, -20],
          // formatter: function(params) {
          //   const arr = ['zero', 'one', 'two', 'three', 'four'];
          //   return '{'+ arr[params.dataIndex] +'|'+ params.value +'%}\n{name|'+ params.name +'}';
          // },
          // edgeDistance: 10,
          // lineHeight: 16,
          // rich: {

          //   name: { fontSize: 14, color: '#fff', padding: [5, 0, 0, 0] }
          // }
          rich: {
            a: {
              fontSize: '18px',
              fontWeight: 'bold',
              align: 'center'
            },
            // zero: {
            //   fontSize: '18px', fontWeight: 'bold',
            //   align: 'center', padding: [0, 0, 0, 0]
            // },
            // one: {
            //   fontSize: '18px', fontWeight: 'bold',
            //   align: 'center', padding: [0, 0, 0, 0]
            // },
            // two: {
            //   fontSize: '18px', fontWeight: 'bold',
            //   align: 'center', padding: [0, 0, 0, 0]
            // },
            // three: {
            //   fontSize: '18px', fontWeight: 'bold',
            //   align: 'center', padding: [0, 0, 0, 0]
            // },
            // four: {
            //   fontSize: '18px', fontWeight: 'bold',
            //   align: 'center', padding: [0, 0, 0, 0]
            // },
            // five: {
            //   fontSize: '18px', fontWeight: 'bold',
            //   align: 'center', padding: [0, 0, 0, 0]
            // },
            name: {
              fontSize: '14px',
              fontWeight: 'bold',
              align: 'center'
            }
          },
        },
        labelLine: {
          length: 30,
          length2: 40,
          maxSurfaceAngle: 40,
          normal: {
            lineStyle: {
              color: '#f9b000'
            }
          }
        },
        labelLayout: function (params: any) {
          const isLeft = params.labelRect.x < pieRef.current.getWidth() / 2;
          const points = params.labelLinePoints;

          // Update the end point.
          points[2][0] = isLeft
            ? params.labelRect.x
            : params.labelRect.x + params.labelRect.width;
          return {
            labelLinePoints: points
          };
        },
      },
    ]
  }
  const barOption = {
    tooltip: {
      trigger: 'axis',
      formatter: function (params: any) {
        // 假设 params.seriesName 是实际数据的系列名
        if (params[0].seriesName == 'data') {
          // 只返回实际数据的值
          return (
            params[0].name +
            '<br/>' +
            params[0].seriesName +
            ': ' +
            params[0].value +
            '%'
          );
        }
        // 对于剩余部分的数据，不返回任何内容，这样 tooltip 就不会显示
        return '';
      }
    },
    legend: {
      data: ['柱状图1', '柱状图2']
    },
    xAxis: [
      {
        type: 'value',
        boundaryGap: [0],
        // position: 'bottom',
        data: ['总量'],
        max: 100,
        // scale: 0.8,
        axisLine: {
          show: false // 是否显示坐标轴线
        },
        axisTick: {
          // 控制刻度
          show: false // 不显示刻度
        },
        axisLabel: {
          // 控制坐标轴标签
          show: false // 不显示坐标轴标签
        },
        splitLine: {
          // 控制网格线
          show: false // 不显示网格线
        }
      }
    ],
    yAxis: [
      {
        type: 'category',
        inverse: true,
        max: 6,
        data: [
          t('section5.chart2.item1tit'),
          t('section5.chart2.item2tit'),
          t('section5.chart2.item3tit'),
          t('section5.chart2.item4tit'),
          t('section5.chart2.item5tit'),
        ],
        axisLabel: {
          fontSize: '18px',
          lineHeight: 20,
          align: 'right',
          margin: 10,
          fontWeight: '600',
          color: '#F9B000'
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false,
          lineStyle: {
            color: '#f5f5f5'
          }
        }
      }
    ],
    series: [
      {
        name: 'data',
        type: 'bar',
        // barGap: ,
        barGap: '-120%',
        // barCategoryGap: '100%',
        stack: 'data',
        itemStyle: {
          color: '#transparent',
          borderColor: 'transparent',
        },
        z: 10,
        barWidth: 20,
        offset: [20, 0],
        data: [1, 1, 1, 1, 1]
      },
      {
        name: 'data1',
        type: 'bar',
        // barGap: ,
        barGap: '-120%',
        barCategoryGap: '50%',
        animationDuration: 2500,
        stack: 'data',
        itemStyle: {
          color: '#fff',
          barBorderRadius: 20,

        },
        label: {
          show: true,
          position: 'left',
          formatter: function (params: any,) {
            return '{a|' + params.value + '%}';
          },
          offset: [50, 0],
          rich: {
            a: {
              fontSize: 14,
              color: '#fcb814',
              fontFamily: '微软雅黑',
              fontWeight: '600',
            }
          },
          // padding: [4, 8, 1]
        },
        z: 10,
        barWidth: 20,
        offset: [20, 0],
        data: [
          t('section5.chart2.item1num'),
          t('section5.chart2.item2num'),
          t('section5.chart2.item3num'),
          t('section5.chart2.item4num'),
          t('section5.chart2.item5num'),
        ]
      },
      {
        name: "小圆球",
        type: "pictorialBar",
        symbol: "circle", // 如果使用图片，则替换为"image://data:image/png;base64,..."
        symbolSize: [20, 20], // 小圆球的大小
        symbolOffset: [35, -2], // 小圆球相对于柱形的偏移量
        z: 3,
        itemStyle: {
          normal: {
            color: "#FFFFFF" // 小圆球的颜色
          }
        },
        data: [
          { value: t('section5.chart2.item1num'), symbolPosition: "end" },
          { value: t('section5.chart2.item2num'), symbolPosition: "end" },
          { value: t('section5.chart2.item3num'), symbolPosition: "end" },
          { value: t('section5.chart2.item4num'), symbolPosition: "end" },
          { value: t('section5.chart2.item5num'), symbolPosition: "end" },
        ]
      },
      {
        name: '剩余部分',
        type: 'bar',
        // stack: '总量',
        barWidth: 28,
        // label: {
        //   show: true,
        //   position: 'right',
        //   formatter: function (params: any,) {
        //     const data = [5, 13, 16, 25, 41].reverse()
        //     var percent = data[params.dataIndex] + '%'; // 计算并格式化占比
        //     return '{a|' + percent + '}';
        //   },
        //   rich: {
        //     a: {
        //       fontSize: 16,
        //       color: '#fcb814',
        //       fontFamily: '微软雅黑',
        //       fontWeight: '500'
        //     }
        //   },
        //   // padding: [4, 8, 1]
        // },
        itemStyle: {
          // color: '#d0e4b6',
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 1,
            y2: 0,
            colorStops: [
              { offset: 0, color: '#d0e4b6' },
              { offset: 0.5, color: '#fcd763' },
              { offset: 1, color: '#f0b582' }
            ]
          },
          barBorderRadius: 20,
        },
        data: (function () {
          return Array(5).fill(100);
        })()
      }
    ],
    grid: {
      top: '0',
      left: '0',
      right: '0',
      bottom: '0',
      containLabel: true
    }
  }

  const chunkArray = useCallback((arr: any, chunkSize: number) => {
    const chunkedArray = [];
    let index = 0;
    while (index < arr.length) {
      const end = Math.min(index + chunkSize, arr.length);
      chunkedArray.push(arr.slice(index, end));
      index = end;
    }
    return chunkedArray;
  }, [])

  useEffect(() => {
    setTimeout(() => {
      const str = document.getElementById("reactCode")?.innerText || 'console.log()';
      eval(str)
    }, 0);
  }, [menuDetail]);

  useEffect(() => {
    pieRef.current = echarts.init(document.getElementById('pie'))
    pieRef.current.setOption(pieOption)
    barRef.current = echarts.init(document.getElementById('bar'))
    barRef.current.setOption(barOption)
  }, [menuDetail])

  return (
    <div>
      <Wrapper>
        <div className={cName(styles.container, 'm-1600')}>
          {getHead(menuDetail)}
          <div className={styles.intro}>
            <div>
              <img src="/image/logo.png?v=20250422" alt="" />
              <h2>{t('section1.title')}</h2>
              <ul>
                <li>
                  <div>
                    <p><CountUp
                      end={Number(t('section1.item1num'))}
                      duration={1}
                      enableScrollSpy
                    /><span></span></p>
                    <span>{t('section1.item1tit')}</span>
                  </div>
                </li>
                <li>
                  <div>
                    <p><CountUp
                      end={Number(t('section1.item2num'))}
                      duration={1}
                      enableScrollSpy
                    /><span></span></p>
                    <span>{t('section1.item2tit')}</span>
                  </div>
                </li>
                <li>
                  <div>
                    <p><CountUp
                      end={Number(t('section1.item3num'))}
                      duration={1}
                      enableScrollSpy
                    /><span>+</span></p>
                    <span>{t('section1.item3tit')}</span>
                  </div>
                </li>
              </ul>
              {
                t.rich('section1.text', {
                  p: (chunks) => <p>{chunks}</p>,
                  br: () => <br />,
                })
              }
            </div>
          </div>
          <img src="https://img.cbcechina.com/2024-11-26/79a872efa046ad03e1642fc57d7f1362.png" alt="" />
          <div className={styles.vLogo}>
            <h3>{t('section2.title')}<span>{t('section2.subtitle')}</span></h3>
            <Swiper
              className={styles.swiper}
              modules={[Autoplay, Pagination]}
              spaceBetween={0}
              autoplay
              pagination={{ clickable: true }}
              slidesPerView={1}
            >
              {
                data.spectator_list &&
                chunkArray(data.spectator_list, 27)
                  ?.map((item: any, index: number) => (
                    <SwiperSlide key={index}>
                      <ul className={styles.audiList}>
                        {
                          item.map((child: any, idx: number) => (
                            <li key={idx}>
                              <Link href={child[`link_${router.locale}`] ? child[`link_${router.locale}`] : "javascript:;"}>
                                <a target={child[`link_${router.locale}`] ? '_blank' : '_self'}>
                                  <img loading='lazy' src={child.image} alt={child[`title_${router.locale}`]} />
                                </a>
                              </Link>
                            </li>
                          ))
                        }
                      </ul>
                    </SwiperSlide>
                  ))
              }
            </Swiper>
          </div>
          <div className={styles.vComment}>
            <h3>{t('section3.title')}</h3>
            <div>
              <div className={styles.left}>
                <Swiper
                  autoplay
                  modules={[Autoplay, Pagination]}
                  slidesPerView={1}
                  autoHeight={true}
                  pagination={{ clickable: true }}
                >
                  <SwiperSlide>
                    <div className={styles.swiperItem}>
                      <div className={styles.logo}>
                        <div>
                          <img src="https://img.cbcechina.com/2026-11-02/2f1d231a4248771b07bf160ea2234f14.png" alt="" />
                        </div>
                      </div>
                      <p className={styles.name}>{t('section3.item1name')}</p>
                      <p className={styles.position}>{t('section3.item1label')}</p>
                      <p>{t('section3.item1txt')}</p>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
              <div className={styles.right}>
                <Swiper
                  autoplay
                  modules={[Autoplay, Pagination]}
                  slidesPerView={1}
                  autoHeight={true}
                  pagination={{ clickable: true }}
                >
                  <SwiperSlide>
                    <div className={styles.swiperItem}>
                      <div className={styles.logo}>
                        <div>
                          <img src="https://img.cbcechina.com/2026-11-02/e78c4d36cce415bd09f30c495a74eea7.png" alt="" />
                        </div>
                      </div>
                      <p className={styles.name}>{t('section3.item2name')}</p>
                      <p className={styles.position}>{t('section3.item2label')}</p>
                      <p>{t('section3.item2txt')}</p>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
          </div>
          <div className={styles.photo}>
            <h3>{t('section4.title')}</h3>
            {data.atlas_list && <div className={styles.photoList}>
              <div className={styles.top}>
                <img src={data.atlas_list[0]?.photo} alt={data.atlas_list[0]?.[`brief_${router.locale}`]} />
                <div>
                  <img src={data.atlas_list[1]?.photo} alt={data.atlas_list[1]?.[`brief_${router.locale}`]} />
                  <img src={data.atlas_list[2]?.photo} alt={data.atlas_list[2]?.[`brief_${router.locale}`]} />
                </div>
                <img src={data.atlas_list[3]?.photo} alt={data.atlas_list[3]?.[`brief_${router.locale}`]} />
              </div>
              <div className={styles.bottom}>
                <div>
                  <img src={data.atlas_list[4]?.photo} alt={data.atlas_list[4]?.[`brief_${router.locale}`]} />
                  <img src={data.atlas_list[5]?.photo} alt={data.atlas_list[5]?.[`brief_${router.locale}`]} />
                </div>
                <img src={data.atlas_list[6]?.photo} alt={data.atlas_list[6]?.[`brief_${router.locale}`]} />
                <img src={data.atlas_list[7]?.photo} alt={data.atlas_list[7]?.[`brief_${router.locale}`]} />
                <img src={data.atlas_list[8]?.photo} alt={data.atlas_list[8]?.[`brief_${router.locale}`]} />
              </div>
            </div>}
            <a href="/media/photo">
              <div className={classNames([styles.more, 'btnStyle'])}>
                <span>{t('section4.more')}</span>
                {/* @ts-ignore */}
                <svg t="1723196878237" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2672" width="14" height="14">
                  <path d="M320 0 192 128l384 384-384 384 128 128 512-512L320 0z" p-id="2673" fill="#231F20">
                  </path>
                </svg>
              </div>
            </a>
          </div>
          <div dangerouslySetInnerHTML={{ __html: menuDetail?.info?.content }} />
          <section className={styles.guests}>
            <div className={cName(styles.inner)}>
              <h3>{t('section8.title')}</h3>
              {
                false ?
                  <Swiper
                    className={cName(styles.swiper, styles.defaultSwiper)}
                    modules={[Autoplay, Pagination]}
                    autoplay
                    pagination={{ clickable: true }}
                    slidesPerView={2}
                    slidesPerGroup={2}
                    spaceBetween={20}
                    breakpoints={{
                      1440: {
                        slidesPerView: 8,
                        slidesPerGroup: 8,
                      },
                      1024: {
                        slidesPerView: 6,
                        slidesPerGroup: 6,
                      },
                      768: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                      },
                      576: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                      },
                    }}
                  >
                    {
                      guestList?.map((item: any, index: number) => (
                        <SwiperSlide key={index}>
                          <div className={styles.item}>
                            <div className={styles.avatar}>
                              <img src={item.image} alt={item[`title_${router.locale}`]} loading='lazy' />
                            </div>
                            <p className={styles.title}>{item[`title_${router.locale}`]}</p>
                            <p className={styles.brief}>{item[`brief_${router.locale}`] || "职位"}</p>
                          </div>
                        </SwiperSlide>
                      ))
                    }
                  </Swiper>
                  :
                  <ul className={styles.list}>
                    {
                      guestList?.map((item: any, index: number) => (
                        <li className={styles.item} key={index}>
                          <div className={styles.avatar}>
                            <img src={item.image} alt={item[`title_${router.locale}`]} loading='lazy' />
                          </div>
                          <p className={styles.title}>{item[`title_${router.locale}`]}</p>
                          <p className={styles.brief}>{item[`brief_${router.locale}`]}</p>
                        </li>
                      ))
                    }
                  </ul>
              }
            </div>
          </section>
          <div className={styles.data}>
            <h3>{t('section5.title')}</h3>
            <p>{t('section5.text')}</p>
            <div>
              <div>
                <h4>{t('section5.chart1.title')}</h4>
                <div id='pie' className={styles.pie} />
              </div>
              <div>
                <h4>{t('section5.chart2.title')}</h4>
                <div id='bar' className={styles.bar} />
              </div>
            </div>
          </div>
          <div className={styles.sponsor}>
            <h3>{t('section6.title')}<span>{t('section6.subtitle')}</span></h3>
            <Swiper
              className={styles.swiper}
              modules={[Autoplay, Pagination]}
              spaceBetween={0}
              autoplay
              pagination={{ clickable: true }}
              slidesPerView={1}
            >
              {
                data.brand_list &&
                chunkArray(data.brand_list, 18)
                  ?.map((item: any, index: number) => (
                    <SwiperSlide key={index}>
                      <ul className={styles.audiList}>
                        {
                          item.map((child: any, idx: number) => (
                            <li key={idx}>
                              <Link href={child[`link_${router.locale}`] ? child[`link_${router.locale}`] : "javascript:;"}>
                                <a target={child[`link_${router.locale}`] ? '_blank' : '_self'}>
                                  <img loading='lazy' src={child.image} alt={child[`title_${router.locale}`]} />
                                </a>
                              </Link>
                            </li>
                          ))
                        }
                      </ul>
                    </SwiperSlide>
                  ))
              }
            </Swiper>
          </div>
          <div className={styles.lookback}>
            <h3>{t('section7.title')}</h3>
            <Swiper
              onObserverUpdate={(swiper: any) => {
                swiper.slideNext()
              }}
              autoplay
              className='lookback'
              modules={[Autoplay, Pagination]}
              slidesPerView='auto'
              pagination={{ clickable: true }}
            >
              {
                data.review_list?.map((item: any, index: number) => (
                  <SwiperSlide key={index}>
                    <Link href={item.file}>
                      <a target='_blank' className={styles.lookItem}>
                        <p>{item.title}<span>{t('section7.unit')}</span></p>
                        <span>{t('section7.label')}</span>
                        <div className={styles.bg} style={{
                          opacity: `${1 - index * 0.09}`
                        }}></div>
                      </a>
                    </Link>
                  </SwiperSlide>
                ))
              }
            </Swiper>
          </div>
          <style jsx global lang='scss'>
            {
              `
              .lookback .swiper-wrapper :first-child a{
                 background-image: url(/image/lookback-li-first-bg.png);
                 background-size: 100% 100%;
              }
              .swiper-slide{
                width:auto;
                padding-bottom:30px;
              }
              .swiper-pagination{
                bottom: 0 !important;
              }
              .swiper-pagination-bullet{
                width: 40px;
                height: 6px;
                border-radius: 2px;
                background-color: #231f20;
              }
              .swiper-pagination-bullet{
                background-color: rgb(0 0 0 / 80%);
              }
              .swiper-pagination-bullet-active{
                background-color:#F6A800 !important;
              }
            `
            }
          </style>
        </div>
      </Wrapper>
    </div>
  );
};